import { useNavigate } from "react-router";
import styles from "./popular-blogs.module.css";
import stylee from "../soldout-projects/SoldoutProjects.module.css";
import MediaAssets from "assets";
import { getPreLoginPageAction } from "redux-container/pre-login-page-management-redux/PreLoginPageManagementRedux";
import { useSelector, useDispatch } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Tooltip as ReactToolTip } from "react-tooltip";

const actionDispatch = (dispatch: any) => {
  return {
    getPreLoginPageDetails: (params: any) =>
      dispatch(getPreLoginPageAction.getPreLoginPagesRequest(params)),
    getProjectContentList: (params: any) =>
      dispatch(getPreLoginPageAction.getProjectContentsRequest(params)),
    setPagemanagementState: (key: any, value: any) =>
      dispatch(getPreLoginPageAction.setPageState(key, value)),
  };
};

const PopularBlogs = () => {
  const navigate = useNavigate();

  const blogs = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData
      ?.pageManagementOrLatestUpdates;
  });
  const blogsHeading = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData?.page?.latestUpdates
      ?.heading;
  });

  const truncated = (str: string, maxLength: number) => {
    if (str?.length > maxLength) {
      return str.slice(0, maxLength - 1) + "...";
    }
    return str;
  };

  if (!blogs) {
    return <></>;
  }
  return (
    <>
      <div className={styles.blogWrapper}>
        <div className={stylee.top_div_style} style={{ marginBottom: "2rem" }}>
          <div className={stylee.slider_icon_style}>
            {/* <img src={MediaAssets.explore_icon} /> */}
          </div>
          <h4 className={stylee.heading_style}>Insights for you</h4>
          <div
            className={stylee.slider_div_btn}
            style={{ color: "white", marginLeft: "-20px" }}
            onClick={() => {
              navigate("/blog");
            }}
          >
            READ ALL BLOGS
            <LazyLoadImage
              src={MediaAssets.arrow_left}
              style={{ marginLeft: "4px" }}
            />
          </div>
        </div>
        {/* popular blogs (insights for you) */}
        <div className={styles.blogContainer}>
          {blogs &&
            blogs?.slice(0, 5).map((blog: any, index: number) => {
              return (
                <div
                  key={blog.id}
                  className={styles.innerCon}
                  onClick={() => {
                    navigate(
                      `/blog/${blog.displayTitle
                        .replace(/%20|\s/g, "-")
                        .replace(/\//g, "-")}`,
                      {
                        state: { blogDetails: blog },
                      }
                    );
                  }}
                >
                  <div
                    className={styles.blogData}
                    style={{
                      height: "45%",
                      width: "100%",
                    }}
                  >
                    <LazyLoadImage
                      className={styles.blogImg}
                      src={blog?.detailedInfo[0]?.media?.value?.url}
                      alt="Landing page"
                    />
                  </div>
                  <div className="" style={{ marginTop: "1rem" }}>
                    <h1
                      data-tooltip-id={`my-tooltip-${index}`}
                      className={styles.blogHeading}
                    >
                      {truncated(blog?.displayTitle, 50)}
                    </h1>
                    <ReactToolTip
                      id={`my-tooltip-${index}`}
                      place="bottom"
                      // variant="info"
                      content={`${blog?.displayTitle}`}
                      style={{
                        width: "20%",
                        fontSize: "1rem",
                        lineHeight: "1rem",
                      }}
                      className="tooltip"
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default PopularBlogs;
